/* eslint-disable */
// @ts-nocheck
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Alert,
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import StorageIcon from "@mui/icons-material/Storage";
import { BORDER_RADIUS } from "../../theme/theme";

const StorageProviderDialog = ({
  storageConfirmDialog,
  setStorageConfirmDialog,
  isMigrationActionLoading,
  setPendingStorageProvider,
  storageProvider,
  pendingStorageProvider,
  isFetchingDrives,
  selectedDriveId,
  setSelectedDriveId,
  availableDrives,
  confirmAndStartMigration,
}: any) => {
  return (
    <Dialog
      open={storageConfirmDialog}
      onClose={() => {
        if (!isMigrationActionLoading) {
          setStorageConfirmDialog(false);
          setPendingStorageProvider("");
        }
      }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <StorageIcon color="warning" />
        Confirm Storage Provider Change
      </DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          <Typography variant="body2" fontWeight={600} gutterBottom>
            Important: This is a critical operation
          </Typography>
          <Typography variant="body2">
            Changing storage providers will trigger a background migration
            of all your files. This process may take several minutes
            depending on the number of files.
          </Typography>
        </Alert>
        <Typography variant="body1" paragraph>
          You are about to switch from{" "}
          <strong>
            {storageProvider === "AZURE"
              ? "Prospo Storage"
              : "SharePoint"}
          </strong>{" "}
          to{" "}
          <strong>
            {pendingStorageProvider === "AZURE"
              ? "Prospo Storage"
              : "SharePoint"}
          </strong>
          .
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {pendingStorageProvider === "SHAREPOINT"
            ? "Your files will be migrated to your Microsoft 365 SharePoint. You can access them through SharePoint after migration completes."
            : "Your files will be migrated back to Prospo Storage. This is the default storage option."}
        </Typography>

        {/* --- NEW: Pre-flight Location Verification Picker --- */}
        {pendingStorageProvider === "SHAREPOINT" && (
          <Box
            sx={{
              mt: 3,
              p: 2,
              bgcolor: "#f8fafc",
              borderRadius: BORDER_RADIUS,
              border: "1px solid #e2e8f0",
            }}
          >
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
              Verify Target SharePoint Site:
            </Typography>
            {isFetchingDrives ? (
              <Box display="flex" alignItems="center" gap={1}>
                <CircularProgress size={20} />
                <Typography variant="body2">
                  Fetching available sites...
                </Typography>
              </Box>
            ) : (
              <FormControl fullWidth size="small">
                <InputLabel>Select SharePoint Site</InputLabel>
                <Select
                  value={selectedDriveId}
                  onChange={(e) =>
                    setSelectedDriveId(e.target.value as string)
                  }
                  label="Select SharePoint Site"
                >
                  {availableDrives.map((drive) => (
                    <MenuItem key={drive.driveId} value={drive.driveId}>
                      {drive.siteName}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  Please verify or select the destination where files
                  should be moved.
                </FormHelperText>
              </FormControl>
            )}
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2, pt: 0 }}>
        <Button
          onClick={() => {
            setStorageConfirmDialog(false);
            setPendingStorageProvider("");
          }}
          disabled={isMigrationActionLoading}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="warning"
          // --- NEW: Bind to the verification function ---
          onClick={confirmAndStartMigration}
          startIcon={
            isMigrationActionLoading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              <StorageIcon />
            )
          }
          // Disable if they haven't picked a location or while loading
          disabled={
            isMigrationActionLoading ||
            (pendingStorageProvider === "SHAREPOINT" &&
              (!selectedDriveId || isFetchingDrives))
          }
        >
          {isMigrationActionLoading ? "Starting..." : "Confirm & Migrate"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StorageProviderDialog;
